import React from "react";
import { Modal, Comment, Header } from "semantic-ui-react";
import { SafeMoment } from "../../../../components/SafeMoment";
import ReactMarkdown from "react-markdown";
import { ImageCarousel, ImageCarouselSize } from "../../../../components/ImageCarousel";
import { AttachmentFile } from "./InspectionItemCommentCard";

export interface IInspectionCommentDeleteItemPreview {
  id: number;
  firstName: string | null;
  lastName: string | null;
  created_at: string;
  comment: string | null;
  commentAttachments: AttachmentFile[];
}

export interface IInspectionItemCommentDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (id: number) => void;
  previewItem: IInspectionCommentDeleteItemPreview | null;
}
export const InspectionItemCommentDeleteModal = (props: IInspectionItemCommentDeleteModalProps) => {
  const { isOpen, onClose, onConfirm, previewItem } = props;
  if (!previewItem) return null;
  const { id, firstName, lastName, created_at, comment, commentAttachments } = previewItem;

  return (
    <Modal open={isOpen} onClose={onClose} size='small' className='tw-max-w-[90%]'>
      <Header content='Confirm Deletion' />
      <Modal.Content>
        <Comment className='tw-flex'>
          <Comment.Content className='pl-0 pt-1 w-full'>
            <Comment.Author as='a'>{`${firstName} ${lastName}`} </Comment.Author>
            <Comment.Metadata>
              <div>
                <SafeMoment format='MMMM D, LT'>{created_at}</SafeMoment>
              </div>
            </Comment.Metadata>
            <div className='comment-body'>
              <ReactMarkdown>{comment}</ReactMarkdown>
            </div>
          </Comment.Content>
        </Comment>
        {commentAttachments && commentAttachments.length > 0 && (
          <ImageCarousel images={commentAttachments} size={ImageCarouselSize.Small} />
        )}
      </Modal.Content>
      <Modal.Actions>
        <button className='ui button' onClick={onClose}>
          Cancel
        </button>
        <button className='ui button red' onClick={() => onConfirm(Number(id))}>
          Delete
        </button>
      </Modal.Actions>
    </Modal>
  );
};
